'use client'
import Markdown from "@/components/atoms/Markdown";
import styles from './PageCardV2.module.scss'
import cn from "clsx";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import { useEffect, useState } from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { FREEZE_RFIS } from "@/components/organisms/HeaderOpt/utils";
import { usePathname } from "next/navigation";

export default function PageCards_V2({
  attraction,
  isLastCard,
  isCampusImmersionPage,
  cardLength=0,
  index,
  isMobile,
  fliptext,
}: {
  attraction: Attraction;
  isLastCard:boolean,
  isCampusImmersionPage?:boolean,
  cardLength:number,
  index:number,
  isMobile?:boolean,
  fliptext?:string,
}) {

  const pathName = usePathname();

  if (!attraction?.Title?.enabled && !attraction?.TitleDescription?.enabled && !attraction?.Subtitle?.enabled)
    return null
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          (prevIndex + 1) % cardLength
        );
      }, 2500);
  
      return () => clearInterval(interval);
    }, [cardLength]);
    const icon = strapiSingleAttribute(attraction?.Image?.source);
  const styleVars: any = attraction?.isOutline
  ? {
      backgroundColor: attraction?.BorderColor,
      color: attraction?.fliptextColor,
      borderColor: attraction?.BorderColor,
    }
  : {
      backgroundColor: attraction?.BorderColor,
      color: attraction?.fliptextColor,
    };
    const AnnouncementItemStyles = {
      borderColor  : attraction?.BorderColor,
      backgroundColor:attraction?.isOutline?"":attraction?.BorderColor,
      color: attraction?.textColor,
    }

    const config = {
      Content: {
        text: attraction?.Subtitle?.text,
        enabled: attraction?.Subtitle?.enabled,
      },
    };
    const scholarshipCard=attraction?.Subtitle?.type === "SCHOLARSHIP"
    const router=useRouter();

    const isHiddenRFI = FREEZE_RFIS.includes(pathName) && index == 0

return(
  
    <div id={`announcementCard-${index + 1}`}  onClick={scholarshipCard && !isHiddenRFI ? () => router.push("/scholarship") : undefined} 
    className={cn(styles.announcementCard, { [styles.isScholarshipCard]: scholarshipCard, "cursor-pointer": scholarshipCard && !isHiddenRFI })}>
     {isLastCard &&  isCampusImmersionPage? (
    <div className={cn(styles.Attraction__lastCardImageContainer)}>
      <Image
        src={attraction?.Image?.source?.data?.[0]?.attributes?.url}
        alt={attraction?.Image?.alt || "Last Card Image"}
        width={300} 
        height={200} 
        className={cn(styles.Attraction__lastCardImage)}
      />
    </div>
  ) :(
    <div
    className={cn(styles.announcementInner, {
      [styles.flip]: !scholarshipCard && currentIndex === index
    })}
  >
        {/* Front Side */}
        <div className={styles.announcementItem} style={AnnouncementItemStyles}>
          {attraction?.Title?.enabled && (
            <div className={styles.announcementTitle}>
              <Markdown
                className={cn(styles.title, {
                  [styles.titleWithSubtitle]: attraction?.Image?.source,
                })}
                style={{ fontSize: attraction.fontSizeTitle }}
                sanitize={false}
                id={index === 0 ? 'scholarship-heading' : ''}
                
              >
                {attraction?.Title?.text}
              </Markdown>
            </div>
          )}
        <div  className={attraction?.TitleDescription && !attraction?.TitleDescription.text?"":styles.descriptionDiv}>

          {attraction.TitleDescription?.enabled && (
            <div className={styles.announcementSubtitle}>
              
              <Markdown
                as="p"
                className={cn(styles.titleDescription)}
                style={{ fontSize: attraction?.fontSizeDescription }}
                sanitize={false}
              >
                 {attraction?.TitleDescription?.text} 
              </Markdown>
            </div>
          )}

          {config.Content?.enabled && !isHiddenRFI && (
            <div className={styles.contentParent}>
              <Markdown
                style={{ fontSize: attraction?.fontSizeSubtitle }}
                id = "explorenow"
                className={cn(styles.content, { "underline cursor-pointer": scholarshipCard })}
                sanitize={false}
                onClick={scholarshipCard ? () => router.push("/scholarship") : () => null}
              >
                {config.Content?.text}
              </Markdown>
            </div>

          )}
        </div>
        </div>

        {/* Back Side */}
        <div className={styles.announcementCardBack} style={styleVars}>
            <Markdown 
              className={styles.underDesc}
              sanitize={false}
            >
            {fliptext}
            </Markdown>
        </div>

        {icon?.url && <img
          src={icon?.url}
          alt={icon?.alternativeText || "Page Card"}
          loading='lazy'
        />}
      </div>
     )} 
    </div>
)
}
